export default __webpack_public_path__ + "styles/CardRibbon.222ec21cbb9e888184ff78e4cd6f826e.css";